import React from 'react'
import styled from '@emotion/styled'
import { PAGE_BREAKPOINTS } from 'parameters/index'
import { TopicsSection, TopicsWrapper } from 'experiences/learn/topics/TopicsSection'
import { isTopicRelatedToProduct, Topic } from 'services/ContentfulService/models/topics'
import { ProductWithChildren } from 'services/ContentfulService/models/product'
import { ArticleSummary } from 'services/ContentfulService/models/articles'
import { ApplySection } from '../common/applySection'
import { LearnContainer } from 'experiences/learn/common'
import { TopicHero } from 'experiences/learn/topics/TopicHero'
import { ArticleSection } from 'experiences/shared/ArticleSection'
import { ProductsSection } from '../products/Section'
import { usePageAsset } from 'stores/Contentful/hooks'

interface Props {
	topics: Topic[]
	products: ProductWithChildren[]
	latestArticles: ArticleSummary[]
}

const createTopicSection = (allTopics: Topic[], product: ProductWithChildren): JSX.Element | null => {
	const topics = allTopics.filter(topic => isTopicRelatedToProduct(topic, product))
	const title = product.name
	if (topics.length > 0) return <TopicsSection key={product.id} title={title} topics={topics} />
	return null
}

export const TopicsDirectory = ({ topics, products, latestArticles }: Props): JSX.Element => {
	const heroAsset = usePageAsset('hero_image')
	return (
		<TopicsRootWrapper>
			<TopicHero title={'Explore by Topic'} asset={heroAsset} breadcrumbs={[{ name: 'Learn', url: '/learn' }]} />
			<LearnContainer>
				<div>
					<div style={{ height: '24px' }} />
					{products.map(p => createTopicSection(topics, p))}
				</div>
				<div>
					<ProductsTitle>Learn more about the products on our network</ProductsTitle>
					<ProductsSection products={products} />
				</div>
				<ArticleSection
					title="Latest Articles"
					articles={latestArticles.slice(0, 8)}
					linkTo="/learn/articles"
					isSmallCard
				/>
			</LearnContainer>
			<ApplySection />
		</TopicsRootWrapper>
	)
}

const TopicsRootWrapper = styled.div`
	${TopicsWrapper} {
		margin-bottom: 48px;
	}
`

const ProductsTitle = styled.h2`
	margin-top: 96px;

	@media screen and (${PAGE_BREAKPOINTS.TABLET_PORTRAIT}) {
		margin-top: 48px;
	}
`
